import * as React from "react";
const SvgInfoWhite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <g fill="#fff">
      <path
        fillRule="evenodd"
        d="M20 29.24a9.24 9.24 0 1 0 0-18.48 9.24 9.24 0 0 0 0 18.48M20 31c6.075 0 11-4.925 11-11S26.075 9 20 9 9 13.925 9 20s4.925 11 11 11"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M20 18.02a.88.88 0 0 1 .88.88v5.5a.88.88 0 0 1-1.76 0v-5.5a.88.88 0 0 1 .88-.88"
        clipRule="evenodd"
      />
      <path d="M21.1 15.6a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0" />
    </g>
  </svg>
);
export default SvgInfoWhite;
